export const SPECIAL_VERIFICATION_SESSION_ID_KEY = 'specialVerificationSessionId'
